export default {
    getHeaderFields: state => state.headerFields,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen,
    isEmailTemplateFormOpen: state => state.emailTemplateFormOpen,
    isExcelImportFormOpen: state => state.excelImportFormIsOpen,

    isUniqueDurationGridOpen: state => state.uniqueDurationGridIsOpen,
    isUniqueDurationFormOpen: state => state.uniqueDurationFormIsOpen,
    getUniqueDurationAdditionalTableConfig: state => state.uniqueDurationAdditionalTableConfig,
    getUniqueDurationActions: state => state.uniqueDurationActions,
    getUniqueDurationFormActions: state => state.uniqueDurationFormActions,
    getUniqueDurationRowActions: state => state.uniqueDurationRowActions,
    getUniqueDurationHeaderFields: state => state.uniqueDurationHeaderFields,
    getUniqueDurationSearchFields: state => state.uniqueDurationSearchFields,
    getExcelImportHeaderFields: state => state.excelImportHeaderFields,
    getExcelImportFormActions: state => state.excelImportFormActions,
}
